import * as z from "zod/v4";

export const setReturnsTiktokIntegrationSettings = {
  name: "setReturnsTiktokIntegrationSettings" as const,
  input: z.object({ isUsingRedoReturnLabels: z.boolean() }),
  output: z.null(),
};
